import {
  Button,
  Divider,
  LinearProgress,
  Portal,
  Snackbar,
} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import TextFieldMUI from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Axios from 'axios';
import Signature from 'components/Editors/Signature';
import {Title} from 'components/forms';
import {i18n2} from 'features/i18n/i18n';
import {Field, Form, Formik} from 'formik';
import {TextField} from 'formik-material-ui';
import React, {useEffect, useRef, useState} from 'react';
import {postValidCourses} from 'constants/url';
import {useGetTokenAndUser, getCoursesByProfile} from '../../hooks';

const SignatureDialog = ({open, setOpen, row, refresh}) => {
  const [message, setMessage] = useState({
    text: '',
    open: false,
    active: false,
  });
  const {token, user} = useGetTokenAndUser();
  const [courses, setCourses] = useState([]);
  const mount = useRef(true);

  useEffect(() => {
    if (mount.current) {
      getCoursesByProfile(row.iD_Profile, row.iD_Sector, token).then((data) => {
        setCourses(data);
      });
    }
    return () => (mount.current = false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClose = () => {
    setOpen(false);
  };

  const submit = async (values, formikBag) => {
    // Se puede mejorar esto?
    try {
      const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const response = await Axios.post(
        postValidCourses,
        JSON.stringify(JSON.stringify(values)),
        {
          headers,
        },
      );
      if (response.status === 200) {
        formikBag && formikBag.setSubmitting(false);
        setMessage({text: 'Agregado correctamente', open: true, active: true});
        refresh();
      } else {
        setMessage({text: response.statusText, open: true, active: false});
      }
    } catch (e) {
      console.error(e.response);
      setMessage({text: e.response.data, open: true, active: false});
    }
  };

  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={'md'}
        fullWidth={true}>
        <Title
          onClose={onClose}
          title={i18n2._('Agregar / Quitar requerimientos a cursos')}
        />
        <Divider />
        <DialogContent>
          <Formik
            initialValues={{
              iD_Profile: row.iD_Profile,
              profile_Name: row.name,
              iD_Sector: row.iD_Sector,
              course: courses.filter((c) => c.alreadyAssigned),
              reason: '',
              pass: '',
              user: user,
            }}
            enableReinitialize
            onSubmit={submit}>
            {(formikProps) => {
              return (
                <Form>
                  <Grid container spacing={2}>
                    <Grid item sm={6} xs={12} style={{padding: 20}}>
                      <Field
                        label={i18n2._('#Perfil')}
                        name={'iD_Profile'}
                        variant="outlined"
                        fullWidth
                        component={TextField}
                        disabled={true}
                      />
                    </Grid>
                    <Grid item sm={6} xs={12} style={{padding: 20}}>
                      <Field
                        label={i18n2._('Nombre del perfil')}
                        name={'profile_Name'}
                        variant="outlined"
                        fullWidth
                        component={TextField}
                        disabled={true}
                      />
                    </Grid>
                    <Grid item sm={12} xs={12} style={{padding: 20}}>
                      <Autocomplete
                        name="course"
                        multiple
                        id="tags-standard"
                        options={courses}
                        value={formikProps.values.course}
                        loading={courses.length === 0}
                        loadingText={'Cargando lista...'}
                        getOptionLabel={(option) =>
                          `${option.name} - V${option.version}`
                        }
                        onChange={(_, value) => {
                          if (value !== null) {
                            formikProps.setFieldValue('course', value);
                          } else {
                            formikProps.setFieldValue('course', '');
                          }
                        }}
                        renderInput={(params) => (
                          <TextFieldMUI
                            {...params}
                            variant="outlined"
                            label={i18n2._('Cursos')}
                          />
                        )}
                      />
                    </Grid>

                    <Signature
                      user={user}
                      customPadding={null}
                      errors={formikProps.errors}
                      touched={formikProps.touched}
                    />
                    {formikProps.isSubmitting && <LinearProgress />}
                  </Grid>
                  <Grid style={{textAlign: 'right'}}>
                    <Button onClick={onClose} style={{color: 'red'}}>
                      {i18n2._('Cancelar')}
                    </Button>
                    <Button
                      type="submit"
                      color="primary"
                      autoFocus
                      disabled={formikProps.isSubmitting}>
                      {i18n2._('Firmar')}
                    </Button>
                  </Grid>
                </Form>
              );
            }}
          </Formik>
        </DialogContent>
      </Dialog>
      <Portal>
        <Snackbar
          open={message.open}
          autoHideDuration={5000}
          onClose={() => {
            setMessage({...message, open: false, active: false});
            message.active && setOpen(false);
          }}
          message={message.text}
        />
      </Portal>
    </>
  );
};

export default SignatureDialog;
